@if (!!modalId) {
  <div class="d-flex w-100" [ngClass]="{ 'mb-2': searchable }">
    <button
      [attr.data-bs-target]="'#begriffserklaerungen-' + modalId"
      data-bs-toggle="modal"
      class="now-btn now-btn-tertiary now-btn-icon now-icon-info-fill"
    >
      <span class="info-text text-nowrap">{{ buttonText }}</span>
    </button>
  </div>
}
